<template>
  <a-row
    gutter="16"
    type="flex"
    align="middle"
    wrap="nowrap"
    class="attendance-summary-row"
  >
    <!-- Present % -->
    <a-col :span="4">
      <a-card class="stat-card">
        <a-progress
          type="circle"
          :percent="Math.floor(overallData.present_percentage || 0)"
          :format="percent => `${Math.floor(percent)}%`"
          :strokeColor="getColor(overallData.present_percentage)"
          :width="60"
          strokeWidth="5"
        />
        <div class="label">Present %</div>
      </a-card>
    </a-col>

    <!-- Other Stats -->
    <a-col
      v-for="(value, label) in statItems"
      :key="label"
      :span="4"
    >
      <a-card class="stat-card">
        <div class="label">{{ formatLabel(label) }}</div>
        <div class="value" :class="getColorClass(label)">
         {{ value != null ? value : 0 }}
        </div>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import { Card, Row, Col, Progress } from 'ant-design-vue'
export default {
  name: 'AttendanceSummaryCard',
  components: {
    'a-card': Card,
    'a-row': Row,
    'a-col': Col,
    'a-progress': Progress,
  },
  props: {
    overallData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    statItems() {
      return {
        total_students: this.overallData.total_students,
        present_count: this.overallData.present_count,
        absent_count: this.overallData.absent_count,
        leave_count: this.overallData.leave_count,
        pending_count: this.overallData.pending_count,
      }
    },
  },
  methods: {
    getColor(percent) {
      if (percent >= 75) return '#52c41a'
      if (percent >= 40) return '#faad14'
      return '#f5222d'
    },
    getColorClass(label) {
      switch (label) {
        case 'present_count':
          return 'present'
        case 'absent_count':
          return 'absent'
        case 'leave_count':
          return 'leave'
        case 'pending_count':
          return 'pending'
        default:
          return ''
      }
    },
    formatLabel(label) {
      return label.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
    },
  },
}
</script>
<style scoped>
::v-deep .ant-progress-text {
  font-weight: bold;
}

.stat-card {
  text-align: center;
  height: 110px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.05);
  padding: 8px; /* Some inner spacing */
}

.label {
  font-size: 15px;
  color: #666;
  font-weight: bold;
  margin-top: 6px;
  line-height: 1.2;
}

.value {
  font-size: 18px;
  font-weight: bold;
  margin-top: 4px;
}

.present {
  color: #52c41a;
}
.absent {
  color: #f5222d;
}
.leave {
  color: #fa8c16;
}
.pending {
  color: #595959;
}

</style>
